import React from 'react';

const StickyContext = React.createContext();


export default StickyContext;